import { FaireHelmet } from "@faire/retailer-visitor-shared/components/Helmet/index";
import { getMetaDescription } from "@faire/retailer-visitor-shared/views/category/__internal__/CategoryPageRoot/__internal__/LoggedOutCategoryPage/__internal__/components/LoggedOutCategoryPageAboveFold/__internal__/utils";
import { useLoggedOutCategoryPageBrandTileReviewsResponse } from "@faire/retailer-visitor-shared/views/category/__internal__/CategoryPageRoot/__internal__/LoggedOutCategoryPage/__internal__/DataFetching/useLoggedOutCategoryPageBrandTileReviewsResponse";
import { useLoggedOutCategoryPageMetaTags } from "@faire/retailer-visitor-shared/views/category/__internal__/CategoryPageRoot/__internal__/LoggedOutCategoryPage/__internal__/DataFetching/useLoggedOutCategoryPageMetaTags";
import { useLoggedOutCategoryPagePrevAndNextPageNumber } from "@faire/retailer-visitor-shared/views/category/__internal__/CategoryPageRoot/__internal__/LoggedOutCategoryPage/__internal__/hooks/usePrevAndNextPageNumber";
import React, { useMemo } from "react";

export const LoggedOutCategoryPageHelmet: React.FC = () => {
  const { seoCategoryText } = useLoggedOutCategoryPageMetaTags();
  const { title, meta_description } = seoCategoryText ?? {};
  const brandsWithReview = useLoggedOutCategoryPageBrandTileReviewsResponse();

  const prevAndNextPageNumber = useLoggedOutCategoryPagePrevAndNextPageNumber();

  const description = useMemo(() => {
    return getMetaDescription(brandsWithReview, meta_description);
  }, [brandsWithReview, meta_description]);

  return (
    <FaireHelmet
      title={title}
      description={description}
      prev={prevAndNextPageNumber.prev}
      next={prevAndNextPageNumber.next}
      alignOpenGraphTitleDescription
    />
  );
};
